import type { User, UserOrContact } from "certiblok-api-manager";

export function isUser(user: any): user is User {
	return user && user.id !== undefined;
}

export function isUserOrContact(user: any): user is UserOrContact {
	return user && user.id !== undefined;
}
